import { IPartnerSignupState } from './state';
import { IPartnerSignupAction } from './action';

export const defaultState: IPartnerSignupState = {
    name: '',
    phone: '',
    authCode: '',
    birthday: '',
};


export interface IPartnerSignUpReducer {
    (state: IPartnerSignupState, action: IPartnerSignupAction): IPartnerSignupState;
}

export default function partnerSignUpReducer(state: IPartnerSignupState, action: IPartnerSignupAction): IPartnerSignupState {
    const { type, value } = action;
    switch (type) {
        case 'SET_STATE':
            if (typeof value === 'object') {
                state = value || state;

            } else {
                state = defaultState;
            }
            break;
        default: state = { ...state, [type]: value, }
            break;
    }
    return state;
}
